export const loadColumns = ({ section }) => (state, actions) => {
  const { [section]: columns } =
    JSON.parse(window.localStorage.getItem("columns")) || {};

  if (columns) {
    actions.setColumns({ columns, section });
  }
};
